import React, {useEffect, useState} from 'react';
import TextInput from "../../../ui_components/TextInput/TextInput";
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import DeliveryTimeInputProperties from "./DeliveryTimeInputProperties";
import {useI18nContext} from "../../../contexts/I18nContext";
import TextInputType from '../../../ui_components/TextInput/TextInputType';

const DeliveryTimeInput: React.FC<DeliveryTimeInputProperties> = ({
                                                        value,
                                                        label,
                                                        placeholder,
                                                        onChange,
                                                        disabled,
                                                        fullWidth = false,
                                                        autoFocus = false,
                                                        className = '',
                                                        error,
                                                        icon = LocalShippingIcon
                                                    }) => {

    const [amount, setAmount] = useState(value);
    const i18n = useI18nContext();

    useEffect(() => {
        setAmount(value);
    }, [value]);

    const onAmountChange = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        const newAmount = +event.target.value;
        console.log(123, newAmount)
        setAmount(newAmount === 0 ? undefined : newAmount);
        onChange(newAmount === 0 ? undefined : newAmount);
    }

    return (
        <TextInput
            type={TextInputType.NUMBER}
            error={error}
            label={label ? label : i18n.translate("DELIVERY_TIME")}
            value={amount}
            placeholder={placeholder}
            disabled={disabled}
            onChange={onAmountChange}
            startIcon={icon}
            className={className}
            fullWidth={fullWidth}
            autoFocus={autoFocus}
        />
    )
}


export default DeliveryTimeInput;